import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_FIELDS } from '@src/graphql/fragments/ehrAppointment'

export const EHR_APPOINTMENT = gql`
  ${EHR_APPOINTMENT_FIELDS}
  query ehrAppointment($id: ID!) {
    ehrAppointment(id: $id) {
      ...EhrAppointmentFields
      payAsYouGoProduct {
        id
        key
        price
        title
        details
        description
        shortDescription
        icon
        ehrSchedulingRule {
          appointmentKind
          chargeKind
          count
          key
        }
      }
    }
  }
`
